import { defineStore } from "pinia";
import api from "@/services/api";

export const useConfigStore = defineStore("config", {
    state: () => ({
        configs: [],
        loading: false,
        fetchedAt: 0,
        ttl: 6 * 60 * 60_000
    }),

    persist: true,

    actions: {
        async fetchConfig(force = false) {
            const now = Date.now();
            
            if (!force && this.configs && now - this.fetchedAt < this.ttl) return;

            this.fetchedAt = now;
            
            const res = await api.get('/config');
            
            this.configs = res.data.data;
        },
        reset() {
            this.configs = [];
        }
    },
});